import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm, change, untouch } from 'redux-form';
import SubmitActions from 'app/common/components/forms/submit-actions';
import { validateResetPassword, ResetPasswordFields } from './password-fields';

import './password.less';

let ResetForm = props => (
  <form className='ResetForm' onSubmit={props.handleSubmit}>
    { ResetPasswordFields() }
    <SubmitActions {...props} />
  </form>
);


ResetForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const form = 'password';
const passwordFields = ['current_password', 'password', 'password_confirmation'];

// Decorate the form component
ResetForm = reduxForm({
  form,
  enableReinitialize: true,
  validate: validateResetPassword,
  // After successfully updating a user's profile, reset the password fields so.
  // they are not available using inspection tools.
  onSubmitSuccess: (result, dispatch) => passwordFields.forEach((field) => {
    dispatch(change(form, field, '')); // reset the field's value
    dispatch(untouch(form, field)); // reset the field's error
  }),
})(ResetForm);


const Password = props => (
  <div className='Password'>
    <h1 className='h2'>Password Reset</h1>
    <ResetForm {...props} />
  </div>
);

Password.propTypes = {};

export default Password;



// WEBPACK FOOTER //
// ./app/components/settings/password.jsx